import { Link } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';

export default function NotFoundPage() {
  useDocumentTitle('صفحه پیدا نشد');

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-10 text-center shadow-sm">
      <p className="text-4xl font-bold text-slate-400">۴۰۴</p>
      <h2 className="mt-3 text-lg font-bold text-slate-800">صفحه مورد نظر پیدا نشد</h2>
      <Link
        to="/dashboard"
        className="mt-4 inline-block rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-800"
      >
        بازگشت به داشبورد
      </Link>
    </div>
  );
}
